import { createStore } from '@stencil/store';
import type { AvailableLocales } from '../components/layouts/default-layout/default-layout.types';

interface Store {
  currentLanguage: AvailableLocales;
  activeVideoTrackingId: string;
  activeVideoTrackingGroupId: string;
}

const { state } = createStore<Store>({
  currentLanguage: null,
  activeVideoTrackingId: null,
  activeVideoTrackingGroupId: null,
});

export default state;
